module.exports = __webpack_public_path__ + "static/media/cases_ilustracoes_new02.b1d60cb6.jpg";